// JavaScript Document
//components/signs/sign.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
//import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
//import Button from '@material-ui/core/Button';
//import ButtonGroup from '@material-ui/core/ButtonGroup';
//import ButtonBase from '@material-ui/core/ButtonBase';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/AddCircle';
import TrashIcon from '@material-ui/icons/Remove';
import Option from '../option/View';
import Popover from '@material-ui/core/Popover';
import Picker from '../option/Picker';
//import Map from './Map';
//import Map from '../../map/Map';
//import SingleMap from '../../map/SingleMap';
//import SaveIcon from '@material-ui/icons/Save';
//import ImagePicker from './ImagePicker';
//import Option from '../option/View';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
	//backgroundColor: theme.palette.background.paper
  },
	formCard : {
		marginBottom: theme.spacing(3),
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
  paper: {
    padding: theme.spacing(2),
    margin: 'auto'
  },
  signTypeItem : {
	  backgroundSize:'contain', 
	  backgroundRepeat:'no-repeat', 
	  backgroundPosition:'center',	
	  textAlign:'center',
  },
	tightCard : {
		display: "flex",
		flexDirection:"column",
		alignItems:"stretch",
		justifyContent:"center",
		flexWrap:"wrap"
	},
	advancedContent : {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		justifyContent: "space-around",
		flexWrap: "wrap"
	},

}));


Picker.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.object.isRequired,
	items: PropTypes.array.isRequired,
};

export default function Options(props) {
	const classes = useStyles();
	const {handleSend, sign, onChange} = props;
	const [signId, setSignId] = React.useState(0);
	const [loaded, setLoaded] = React.useState(false);
	//const [optionsLoaded, setOptionsLoaded] = React.useState(false);
	const [list, setList] = React.useState([]);
	const [signOptions, setSignOptions] = React.useState([]);
	//const [images, setImages] = React.useState([]);
	const [pickerOpen, setPickerOpen] = React.useState(false);
	//const [selectedOption, setSelectedOption] = React.useState({});
	const [changed, setChanged] = React.useState(false);
	//const [optAnchor, setOptAnchor] = React.useState(null);
	const [optPop, setOptPop] = React.useState({
		anchor: null,
		option: {}
	});
	//const [optPopOpen, setOptPopOpen] = React.useState(false);
	const optPopOpen = Boolean(optPop.anchor);

	React.useEffect(() => {
		if(sign && sign.id !== signId){
			setSignId(sign.id);
			if(sign.options){
				setSignOptions(sign.options);
			}
			//var bds = {};
			//basicvars.forEach((bd) => bds[bd] = sign[bd]);
			//setBasic(bds);
		}
		if(!loaded){
			getList();
		}
	   // eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props]);
	
	React.useEffect(() => {
		//if(!optionsLoaded){
		//	setOptionsLoaded(true);
		//} else {
		if(changed){
			if(onChange) {
				//console.log('somethings changed!!!');
				onChange(signOptions);
				setChanged(false);
			}
		}
		//}
	}, [signOptions, changed, onChange]);
	
	const getList = () =>{
		setLoaded(true);
		handleSend({
			vso: 'optionslist'
		}, (data) => {
			setList(data.options);
			//setImages(data.images);
		});
	};
	
	const handleAddOption = () => {
		//open a picker
		//console.log('clicked add option');
		setPickerOpen(true);
	}
	
	const handleClickOption = (e, opt) => {
		//console.log('clicked option');
		//setOptPopOpen(true);
		setOptPop({
			anchor: e.currentTarget,
			option: opt
		});
	}
	const handleRemoveOption = (e) => {
		//console.log('removing option');
		var nso = Object.assign([], signOptions);
		nso.splice(nso.findIndex((o) => o.id === optPop.option.id), 1);
		setChanged(true);
		setSignOptions(nso);
		handleCloseOptPop();
	}
	
	const handleCloseOptPop = () => {
		setOptPop({
			anchor:null,
			//need to leave it or it removes the name before the transition completes
			option: optPop.option
		});
  	};
	const pickerClosed = (opt) => {
		setPickerOpen(false);
		if(opt.id){
			var nso = Object.assign([], signOptions);
			nso.push({
				id: opt.id,
				name: opt.name,
				path: opt.pic_path 
			});
			setChanged(true);
			setSignOptions(nso);
		}
	};

	

	
	//pic_path on list
	return (
		
		<Card className={classes.tightCard}>
			<CardHeader title="Options" action={<Button color="primary" variant="contained" startIcon={<AddIcon />} onClick={handleAddOption}>Add Option</Button>} />
	  		<CardContent className={classes.advancedContent}>
					{signOptions.map((opt, i) => (
					<Button key={i} onClick={(e) => handleClickOption(e, opt)}>
						<Option id={opt.id} path={opt.path} name={opt.name} key={opt.id} />
					</Button>
					))}
	  			</CardContent>
			<Popover
        		id="option_remove_popover"
        		open={optPopOpen}
        		anchorEl={optPop.anchor}
        		onClose={handleCloseOptPop}
        		anchorOrigin={{
          			vertical: 'center',
          			horizontal: 'center',
        		}}
        		transformOrigin={{
          			vertical: 'center',
          			horizontal: 'center',
        		}}
      		>
        		<Button variant="contained" color="secondary" startIcon={<TrashIcon />} onClick={handleRemoveOption} >
					Remove {optPop.option.name}
				</Button>
      		</Popover>
			<Picker open={pickerOpen} onClose={pickerClosed} 
			//selectedValue={selectedOption} 
			items={list.filter(i => signOptions.findIndex(n => n.id === i.id) === -1)} />
	  	</Card>
			
		
	);
}
